// Copyright 2025. WebPros International GmbH. All rights reserved.

export const SET_STORAGE_TYPES_LIST = 'storage-type/SET_STORAGE_TYPES_LIST';
